import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Input, Select, Form, Tabs, Button, Table ,Menu,Row,Col,Breadcrumb,Icon,message,Tree} from 'antd';
/** PERSONAL */
import API from '../../../../API/api';
import * as Types from './../../../../utils/questionType'
import QuestionTagDetail from '../question_tag_detail/view'
import '../style.less'
const { Option } = Select;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const TreeNode = Tree.TreeNode;




class SetTagDetail extends Component {
    state = {
        clickfold:false,
        expandedKeys:[],
        treeNode:[],
        selectedKeys:[],
        page:'',
        question_list:[],
        checkedQuestion:'',
    }
    componentWillMount() {
        this.getTreeData()
        this.getTaskTagType()

    }

    shouldComponentUpdate(nextProps,nextState){
        if(
            nextState.treeData&&(nextState.treeData!==this.state.treeData)//树结构改变
        ){
            this.treeNode=this.loop(nextState.treeData,nextState)
        }
        return true;
    }
    componentDidUpdate(prevProps, prevState) {
        this.watchChange(this.state.selectedKeys,prevState.selectedKeys,()=>{this.getQuestionPage()})//树节点变化时id list改变
    }
    watchChange = (val,newVal,fn,data)=>{
        if(val!==newVal){
           fn(data)
        }
    }
    getTreeData = ()=>{
        let task_id = window.location.href.split('/').pop()
        let data = {
            task_id:task_id
        }
        axios.post(API.QSELECTTNEW_TASK_QUESTION_TREE,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({treeData:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    getTaskTagType = ()=>{
        let task_id = window.location.href.split('/').pop()
        let data = {
            task_id:task_id
        }
        axios.post(API.QSELECTTNEW_TASK_GET_TAG_TYPE,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({task_tag_type:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    pageChange=(val)=>{
        this.setState({page:val})
        setTimeout(()=>{
            this.getQuestionPage(this.state.page)
            document.querySelector('.questionListScroll').scrollTop=0
        },0)
    }
    getQuestionPage = (page=0)=>{
        let task_id = window.location.href.split('/').pop()
        let data = {
            task_id:task_id,
            tree_id:this.state.selectedKeys[0],
            page:page,
        }
        axios.post(API.QSELECTTNEW_TASK_QUESTION_PAGE_CHECK,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                let checkedQuestion = res.data.question_id
                this.changeTreeOneLine(this.state.selectedKeys[0],res.data.tree_update)
                this.setState({checkedQuestion:checkedQuestion});
                this.setState({question_list:res.data.question_list,page:res.data.page,total:res.data.total});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    changeTreeOneLine=(tree_id,tree_update)=>{
        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item.id === key) {
                    return callback(item, index, arr);
                }
                if (item.list) {
                    return loop(item.list, key, callback);
                }
            });
        };
        loop(this.state.treeData, tree_id, (item, index, arr) => {
            item.question_count = tree_update.question_count
            item.question_count_bad = tree_update.question_count_bad
            item.question_count_checkmodify = tree_update.question_count_checkmodify
            item.question_count_checkpass = tree_update.question_count_checkpass
            item.question_count_checkrework = tree_update.question_count_checkrework
            item.question_count_select = tree_update.question_count_select
        });
        this.setState({treeData:[...this.state.treeData]})
    }
    setTagSuccess=()=>{
        this.setState({checkedQuestion:''});
        this.getQuestionPage()
    }

    treeNode=[]

//树结构的loop方法
    loop = (data,nextState) => {
        return data.map((item) => {
            this.state.expandedKeys.push(item.id)
            return <TreeNode  selectable={item.question_count>0}  title={item.question_count>0?<span style={{fontSize:15}}>{item.name}
                                            <span style={{fontSize:15,color:'#999',marginLeft:10,fontWeight:'600'}}>
                                                总题数：
                                                <span style={{color:'#0d84c3'}}>
                                                    {item.question_count}
                                                </span>
                                            </span>
                                            <span style={{fontSize:15,color:'#999',marginLeft:10,fontWeight:'600'}}>
                                                打标签数：
                                                <span style={{color:'#0d84c3'}}>
                                                    {item.question_count_select}
                                                </span>
                                            </span>
                                            <span style={{fontSize:15,color:'#999',marginLeft:10,fontWeight:'600'}}>
                                                返工数：
                                                <span style={{color:'#0d84c3'}}>
                                                    {item.question_count_checkrework}
                                                </span>
                                            </span>
                                        </span>
                                            :
                                        <span style={{fontSize:15}}>{item.name}</span>
            }
                              key={item.id}
            >
                {
                    item.list && item.list.length&&
                    this.loop(item.list,nextState)
                }
            </TreeNode>;
        });
    }
    componentDidMount(){

    }

    //关掉多层（因设置expandedKeys后无法自动关掉多层）
    onTreeExpand=(expandedKeys,obj)=>{
        let expandedKeysSet = new Set(expandedKeys)
        if(!obj.expanded){
            const loop = (data, key, callback) => {
                data.forEach((item, index, arr) => {
                    if (item.id === key) {
                        return callback(item, index, arr);
                    }
                    if (item.list) {
                        return loop(item.list, key, callback);
                    }
                });
            };
            //所有节点执行cb的loop
            const loopAll = (data, callback) => {
                data.forEach((item, index, arr) => {
                    callback(item, index, arr);
                    if(item.list) {
                        return loopAll(item.list, callback);
                    }
                });
            };
            loop(this.state.treeData, obj.node.props.eventKey, (item, index, arr) => {
                //目标节点下的所有节点从expandedKeys中移除
                item.list&&loopAll(item.list,(item1)=>{
                    expandedKeysSet.delete(item1.id)
                })
            });
        }
        this.setState({expandedKeys:[...expandedKeysSet],})

    }
    onSelect = (selectedKeys, info) => {
        if(selectedKeys.length){
            this.setState({selectedKeys:selectedKeys})
        }

    }

    render() {
        let page = this.props.page;
        if(!page){page = 1}
        return (
            <div style={{fontSize:'14px',position:'relative'}}>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>题目管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>审核标签</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row className={'questionPage'} style={{position: 'absolute',top:0,left:300}}>
                    {
                        this.state.question_list&&this.state.question_list.length&&
                        <div>
                            <Button style={{margin:'0 3px',padding:'0 8px'}} disabled={this.state.page==1} onClick={()=>{this.pageChange(this.state.page-1)}}>
                                <Icon type="left" />
                            </Button>
                            {
                                this.state.question_list&&
                                this.state.question_list.map((d,k)=>
                                    <Button key={k}
                                            onClick={()=>{this.setState({checkedQuestion:d.question_id})}}
                                            className={`page stage${d.stage} ${this.state.checkedQuestion==d.question_id?'selected':''}`}
                                            style={{margin:'0 3px',padding:'0 8px',background:'#'}}

                                    >
                                        {(this.state.page-1)*10+k+1}
                                    </Button>
                                )
                            }
                            <Button style={{margin:'0 3px',padding:'0 8px'}}  disabled={this.state.page>=this.state.total/10} onClick={()=>{this.pageChange(this.state.page+1)}}>
                                <Icon type="right" />
                            </Button>

                        </div>
                    }

                </Row>
                <Row style={{marginTop:15}}>

                    <Row>
                        <div>
                            <div style={{width:'calc(58.3%)',position:'absolute',paddingRight:20,minHeight:'300px',height: '100%',}}>
                                <div style={
                                    {background:'#fff',zIndex:19,position:'absolute', height: '100%', left: 0, top: 0, width:'calc(100% - 18px)', transform: this.state.clickfold?'translateX(-105%)':'translateX(0)', transition: 'all 1s'}
                                }>
                                    {/*拉开收起按钮*/}
                                    {

                                        <div style={{borderRadius:3,background:'red',color:'#fff',position:'absolute',width:'18px',top:'150px',right:'-18px',transform: 'translateY(-50%)',padding:'2px',cursor:'pointer'}}
                                             onClick={()=>{this.setState({clickfold:!this.state.clickfold})}}>
                                            {this.state.clickfold?'点击展开任务信息':'点击收起'}
                                        </div>
                                    }

                                    <div>
                                        <Tree
                                            defaultExpandAll={true}
                                            showLine
                                            expandedKeys={this.state.expandedKeys}
                                            selectedKeys={this.state.selectedKeys}
                                            onSelect={this.onSelect}
                                            showIcon={false}
                                            onExpand={this.onTreeExpand}


                                        >
                                            {this.treeNode.map(d=>d)}
                                            {/*更新卡顿*/}
                                            {/*{this.loop(this.state.treeData)}*/}
                                        </Tree>
                                    </div>
                                </div>
                            </div>
                            <QuestionTagDetail tree_id={this.state.selectedKeys[0]} question_id={this.state.checkedQuestion} setTagSuccess={this.setTagSuccess} scene={'checkTask'}  task_tag_type={this.state.task_tag_type}/>
                        </div>
                    </Row>
                </Row>
            </div>
        )
    }
}
const mapStateTopProps = state => {
    return {
        taskList: state.questionManage.setTag.taskList,
    }
}
const mapDispatchToProps = dispatch => {
    return {

    }
};
export default connect(mapStateTopProps, mapDispatchToProps)(SetTagDetail);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/check_tag/view.js